import { useCurrentOrganization } from '@/shared/hooks/api/organization'
import {
  complianceActorDisplayLabel,
  type ComplianceActorLabel,
} from '@/shared/lib/complianceActorDisplayLabel'

export function useComplianceActorDisplayLabel(
  actor: ComplianceActorLabel | null
): string | null {
  const { data: organization } = useCurrentOrganization()
  if (actor == null) {
    return null
  }
  return complianceActorDisplayLabel(actor, organization?.name)
}
